import {
    FETCH_ACTIVITY_DETAILS_START,
    FETCH_ACTIVITY_DETAILS_SUCCESS,
    FETCH_ACTIVITY_DETAILS_FAIL,
    SET_SELECTED_SURF_INDEX,
    FETCH_ACTIVITY_DETAILS_METRICS_FOR_UPDATE_SUCCESS
} from 'actions/ActionTypes';

const INITIAL_STATE = {
    fetching: false,
    lastUpdated: {}
};

const fetchActivityDetailsStart = (state) => ({
    ...state,
    fetching: true
});

const fetchActivityDetailsSuccess = (state, { activityDetails }) => ({
    ...state,
    fetching: false,
    [activityDetails.activityId]: activityDetails,
    lastUpdated: {
        ...state.lastUpdated,
        [activityDetails.activityId]: Date.now()
    }
});

const fetchActivityDetailsFail = (state) => {
    return {
        ...state,
        fetching: false
    };
};

const setSelectedSurfIndex = (state, { typeSplitIndex }) => ({
    ...state,
    typeSplitIndex
});

const fetchActivityDetailsMetricsForUpdateSuccess = (state, action) => {
    const { activityDetails } = action;

    if (!state[activityDetails.activityId]) {
        /** no exist field to update; ignore */
        return {
            ...state,
            fetching: false
        };
    }

    const newActivityDetails = {
        ...activityDetails,
        activityHeatMapDTO: state[activityDetails.activityId].activityHeatMapDTO,
        geoPolylineDTO: state[activityDetails.activityId].geoPolylineDTO
    };

    return {
        ...state,
        fetching: false,
        [activityDetails.activityId]: newActivityDetails,
        lastUpdated: {
            ...state.lastUpdated,
            [activityDetails.activityId]: Date.now()
        }
    };
};

const handlers = {
    [FETCH_ACTIVITY_DETAILS_START]: fetchActivityDetailsStart,
    [FETCH_ACTIVITY_DETAILS_SUCCESS]: fetchActivityDetailsSuccess,
    [FETCH_ACTIVITY_DETAILS_FAIL]: fetchActivityDetailsFail,
    [FETCH_ACTIVITY_DETAILS_FAIL]: fetchActivityDetailsFail,
    [SET_SELECTED_SURF_INDEX]: setSelectedSurfIndex,
    [FETCH_ACTIVITY_DETAILS_METRICS_FOR_UPDATE_SUCCESS]: fetchActivityDetailsMetricsForUpdateSuccess
};

export default function activityDetails(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Getters
export const getActivityDetails = (state, activityId) => state.activityDetails && state.activityDetails[activityId];
export const getActivityDetailsFetchingStatus = (state) => state.activityDetails.fetching;
export const getSelectedSurfIndex = (state) => state.activityDetails.typeSplitIndex;
export const getActivityDetailsLastUpdated = (state, activityId) =>
    state.activityDetails && state.activityDetails.lastUpdated[activityId];
